import { render, staticRenderFns } from "./PieChartIcon.vue?vue&type=template&id=7545bbf3&"
import script from "./PieChartIcon.vue?vue&type=script&lang=ts&"
export * from "./PieChartIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports